// extracted by mini-css-extract-plugin
export default {"info":"wpp_info__A0dIh","wpp":"wpp_wpp__flokl"};